module.exports = __webpack_public_path__ + "media/img/prices/events-35fcb50233f7406cebe2a85eceac937a.png";